import { render, staticRenderFns } from "./BannerWave.vue?vue&type=template&id=fe56c9c2&scoped=true&"
import script from "./BannerWave.vue?vue&type=script&lang=ts&"
export * from "./BannerWave.vue?vue&type=script&lang=ts&"
import style0 from "./BannerWave.vue?vue&type=style&index=0&id=fe56c9c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe56c9c2",
  null
  
)

export default component.exports